function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from './filters.scss';
import template from './filters.html';

export var FiltersComponent = {
  template: template,
  styles: styles,
  bindings: {
    filtersData: "<",
    onSelect: "&" },

  controller: /*#__PURE__*/function () {
    function FiltersComponentController() {
      "ngInject";var _this = this;_classCallCheck(this, FiltersComponentController);
      console.log(this);
      this.swiperOptoins = {
        centeredSlides: false,
        spaceBetween: 12,
        freeMode: true };

      this.currentFilters = [];

      this.onSelectFilter = function (index) {
        var indexInCurrentFilters = _this.currentFilters.indexOf(index);
        if (indexInCurrentFilters === -1) {
          _this.currentFilters.push(index);
        } else
        {
          _this.currentFilters.splice(indexInCurrentFilters, 1);
        }
        _this.onSelect({ filter: _this.currentFilters });
      };
    }_createClass(FiltersComponentController, [{ key: "$onChanges", value: function $onChanges()

      {
        this.swiperOptoins = {
          centeredSlides: false,
          spaceBetween: 12,
          freeMode: true };

      } }, { key: "$postLink", value: function $postLink()

      {
        this.currentFilter = this.filtersData[0];
      } }]);return FiltersComponentController;}() };